import { setIsSuperUser } from '../general/actionTypes';
import {
  displayTournaments, 
  startLoadingTournaments,
  updateShowAllTournaments,
  setCanCreateTournaments,
  displayGroupName
} from './actionTypes';
import {
  navigateTo,
  getJsonAsync
} from 'shared/actions';

const getTournamentsUrl = getState => {
  const showAllTournaments = getState().tournament.tournamentList.showAllTournaments;
  let tournamentsUrl = `setup/tournament/active`;

  if (showAllTournaments){
    tournamentsUrl = `setup/tournament/all`;
  }

  return tournamentsUrl;
};

export const handleManageClick = tournamentId => dispatch =>
  dispatch(navigateTo(`tournament/update/${tournamentId}`));

export const handleCopyClick = tournamentId => dispatch => {
  const copyTournamentUri = window.COPY_TOURNAMENT_BASE_URI;
  window.location = `${copyTournamentUri}/${tournamentId}`;
};

export const retrieveGroupName = () => (dispatch, getState) => {
  const groupName = getState().shared.auth.groupName;
  const roles = getState().shared.auth.roles;

  if (groupName && roles.find(role => role === 'superuser')) {
    dispatch(displayGroupName(groupName));
    dispatch(setIsSuperUser(true));
  }
  else {
    dispatch(displayGroupName(''));
    dispatch(setIsSuperUser(false));
  }
};

export const retrieveTournaments = () => (dispatch, getState) => {
  const tournamentsUrl = getTournamentsUrl(getState);

  dispatch(getJsonAsync(tournamentsUrl))
  .then(data => dispatch(displayTournaments(data)))
  .catch(() => {});
};

export const handleTournamentSearch = () => (dispatch, getState) => {
  const tournamentList = getState().tournament.tournamentList;
  const tournamentsUrl = getTournamentsUrl(getState);
  let searchValue = tournamentList.searchValue;

  if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

  dispatch(startLoadingTournaments());
  dispatch(getJsonAsync(tournamentsUrl))
    .then(data => {
      if (searchValue && searchValue.length > 0) {
        data = data.filter(d => d.name.toLowerCase().indexOf(searchValue) > -1);
      }
      dispatch(displayTournaments(data));
    })
    .catch(() => { });
};

export const handleTournamentSearchEnterKeyPress = event => dispatch => {
  if (event.keyCode === 13) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(handleTournamentSearch());
  }
};

export const handleShowAllTournamentsChange  = checked => dispatch => {
  dispatch(updateShowAllTournaments(checked));
  dispatch(retrieveTournaments());
};

export const retrieveCreateTournamentPermission = () => (dispatch) => {
  dispatch(getJsonAsync(`setup/tournament/checkCreatePermission`))
  .then(data => dispatch(setCanCreateTournaments(data)))
  .catch(() => {});
};


// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/actions.js